import api from '../../api'
import { PaymentsRetentionData } from './paymentsRetentionModel'

export const paymentsRetentionEndpoint = '/web/admin/invoicing-payments-retention'

export const getPaymentsRetention = async () => {
  const response = await api.get<PaymentsRetentionData>(paymentsRetentionEndpoint)
  return response.data
}
